import {ScreenLockService} from "../../core/services/screenLockService/screenLock.service";
import { IAuthenticationService } from '../authentication.service';


export class CallbackController {

    public static $inject = ['screenLockService', 'authenticationService'];

    public constructor(      
        private screenLockService: ScreenLockService, 
        private authenticationService: IAuthenticationService) {

        this.activate();
    }

    public activate() {

        this.screenLockService.broadcast(1);

        this.authenticationService.handleCallback();
    }


}